import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20stage%20with%20soft%20golden%20spotlights%20and%20elegant%20curtains%2C%20luxurious%20theater%20interior%20with%20velvet%20textures%2C%20rich%20warm%20amber%20and%20coral%20tones%2C%20professional%20film%20studio%20aesthetic%2C%20atmospheric%20lighting%2C%20grand%20scale%2C%20inviting%20and%20sophisticated&width=1920&height=1080&seq=hero-bg-mitao&orientation=landscape"
        alt="蜜桃传媒 - 精彩视界触手可及"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-4 leading-tight">
            精彩视界，触手可及
          </h1>
          <p className="text-sm md:text-lg text-background-50/85 mb-8 leading-relaxed max-w-xl mx-auto">
            蜜桃传媒在线观看官方入口，提供全系列高清视频免费在线播放<br className="hidden sm:block" />
            无需下载，随时随地畅享最新内容，画质清晰流畅，多线路稳定播放
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/hot"
              className="px-8 py-3 text-sm font-semibold whitespace-nowrap rounded-full bg-primary-500 text-background-50 cursor-pointer transition-all duration-300 hover:bg-primary-600 active:scale-95"
            >
              <i className="ri-play-circle-fill mr-2"></i>
              立即观看
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 text-sm font-semibold whitespace-nowrap rounded-full border-2 border-background-50/40 text-background-50 cursor-pointer transition-all duration-300 hover:bg-background-50/10 hover:border-background-50/60 active:scale-95"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="flex items-center gap-2 text-background-50/60 text-xs">
          <i className="ri-mouse-line"></i>
          <span>向下滚动探索</span>
          <i className="ri-arrow-down-line"></i>
        </div>
      </div>
    </section>
  );
}